import { useCallback } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

/**
 * "GERİ" = BİR ÖNCEKİ SAYFA (tarayıcının geri tuşu gibi).
 *
 * Sayfalardaki geri düğmelerinin çoğu SABİT bir liste adresine gidiyordu: ürün
 * hareketlerinden açılan fatura "geri"de faturalar listesine atıyordu,
 * kullanıcı geldiği yere dönemiyordu (kullanıcı, 2026-09-28).
 *
 * YEDEK ADRES ŞART: uygulama İÇİNDE önceki bir adım yoksa (sayfa yeni sekmede,
 * yenilemeyle ya da doğrudan adresle açıldıysa) `navigate(-1)` ya hiçbir şey
 * yapmaz ya da uygulamadan ÇIKAR. O durumda eskiden gidilen liste sayfası
 * kullanılır. React Router, oturum içinde kaçıncı adımda olunduğunu
 * `history.state.idx`te tutar.
 */
const oncekiSayfaVar = () => (window.history.state?.idx ?? 0) > 0;

export function useGeri(yedekAdres, yedekSecenek) {
  const navigate = useNavigate();
  // `onClick={geri}` tıklama olayını argüman olarak geçer; bu yüzden
  // fonksiyon hiçbir argüman ALMAZ — olay yanlışlıkla adres sanılmasın.
  return useCallback(() => {
    if (oncekiSayfaVar()) navigate(-1);
    else navigate(yedekAdres, yedekSecenek);
  }, [navigate, yedekAdres, yedekSecenek]);
}

/**
 * AÇIK SEKME ADRESTE durur (`?sekme=movements`), böylece "geri" gelinen
 * SEKMEYE de döner. Ürün kartının Hareketler sekmesinden faturaya gidip geri
 * dönen kullanıcı, sekme yalnızca bileşen durumunda tutulduğu için varsayılan
 * "Stok Durumu" sekmesine düşüyordu — geldiği yer orası değildi.
 * Yazma `replace` ile yapılır: sekme değiştirmek geçmişe adım EKLEMEZ, yoksa
 * "geri" önce sekmeler arasında dolaşırdı.
 */
export function useSekme(varsayilan, anahtar = 'sekme') {
  const [params, setParams] = useSearchParams();
  const sekme = params.get(anahtar) || varsayilan;
  const sekmeSec = useCallback((deger) => {
    setParams((onceki) => {
      const yeni = new URLSearchParams(onceki);
      if (deger === varsayilan) yeni.delete(anahtar); else yeni.set(anahtar, deger);
      return yeni;
    }, { replace: true });
  }, [setParams, varsayilan, anahtar]);
  return [sekme, sekmeSec];
}

/**
 * DÜZENLEME KAYDEDİLİNCE formu AÇTIĞIN YERE dön (detay, liste, ürün hareketleri…).
 *
 * Kaydettikten sonra detaya YENİ bir adım olarak gitmek geçmişi
 * `[… detay, form, detay]` yapıyordu: "geri" basınca kullanıcı az önce
 * kaydettiği FORMA dönüyordu. Formun yerine detay koymak (`replace`) da
 * `[… detay, detay]` bırakır — geri basınca aynı sayfa gelir, "geri çalışmıyor"
 * gibi görünür. Doğrusu formdan geri çıkmak: önceki sayfa yeniden açılır ve
 * güncel veriyi yükler. Önceki adım yoksa detaya gidilir, form geçmişte kalmaz.
 */
export function useDuzenlemeBitti() {
  const navigate = useNavigate();
  return useCallback((detayAdres) => {
    if (oncekiSayfaVar()) navigate(-1);
    else navigate(detayAdres, { replace: true });
  }, [navigate]);
}
